import { RecoveringState } from "../pages";
import { EventEmitter } from 'events';
import { RecoveringActionTypes } from "../common/enums/recoveringEnums";
import { ChangeEvent, TranscriptionEvent } from "./utils";
import Dispatcher from '../dispatcher';

const defaultState: RecoveringState = {
    recoveredTranscriptionFile: null,
    isAudioFileFromDBRecovered: false,
    shouldShowRecoveryCancelDialog: false,
    file: null
};

class RecoveringStore extends EventEmitter {
    private state: RecoveringState;

    constructor() {
        super();

        this.state = this.getInitialState();
    }

    private getInitialState = (): RecoveringState => {
        // Make sure we are not passing a reference to the object
        return Object.assign({}, defaultState);
    }

    public getState = (): RecoveringState => {
        // Make sure we are not passing a reference to the object
        return Object.assign({}, this.state);
    }

    public handleActions = (action: Event): void => {
        switch(action.type) {
            case RecoveringActionTypes.SetRecoveredTranscriptionFile:
                this.state.recoveredTranscriptionFile =  (<TranscriptionEvent> action).payload;
                this.emit(ChangeEvent.Change);
                break;
            case RecoveringActionTypes.SetRecoveryFlowCancelDialog:
                this.state.shouldShowRecoveryCancelDialog = (<TranscriptionEvent> action).payload;
                this.emit(ChangeEvent.Change);
                break;
            case RecoveringActionTypes.SetAudioFile:
                this.state.file = (<TranscriptionEvent> action).payload;
                this.emit(ChangeEvent.Change);
                break;
            case RecoveringActionTypes.SetRecoveredTranscriptionFileInRecoveryFlow:
                this.state.isAudioFileFromDBRecovered = (<TranscriptionEvent> action).payload;
                this.emit(ChangeEvent.Change);
                break;
        }
    }
}

const recoveringStore = new RecoveringStore;
Dispatcher.register(recoveringStore.handleActions);
recoveringStore.setMaxListeners(15); //build error workaroud change
export default recoveringStore;
